import * as angular from "angular";
import {IHttpService, IQService} from "angular";
import {FirebaseAuthResponseModel} from "../../persistence-layer/models/firebase-auth-response.model";
import {ApiConfig} from "../../commons/models/api-config.model";

export class SitesRequestsService {

  /* @ngInject */
  constructor(private $http: IHttpService, private apiConfig: ApiConfig, private $q: IQService) {
  }

  createSite(organizationId, site) {
    const organizations_base_url = this.apiConfig.baseUrl + `/organizations`;

    return this.$http.put(organizations_base_url + '/' + organizationId + '/sites', site)
      .then((res) => {
        return this._sendResponseData(res);
      })
      .catch((error) => {
        return this._sendError(error);
      });
  }

  deleteSite(siteId) {
    const sites_base_url = this.apiConfig.baseUrl + `/sites`;

    return this.$http.delete(sites_base_url + '/' + siteId)
      .then((res) => {
        return this._sendResponseData(res);
      })
      .catch((error) => {
        return this._sendError(error);
      });
  }

  getSite(siteId) {
    const sites_base_url = this.apiConfig.baseUrl + `/sites`;

    return this.$http.get(sites_base_url + '/' + siteId)
      .then((res) => {
        return this._sendResponseData(res);
      })
      .catch((error) => {
        return this._sendError(error);
      });
  }

  getSiteInfo(siteId) {
    const sites_base_url = this.apiConfig.baseUrl + `/sites`;

    return this.$http.get(sites_base_url + '/' + siteId + '/info')
      .then((res) => {
        return this._sendResponseData(res);
      })
      .catch((error) => {
        return this._sendError(error);
      });
  }

  updateSite(siteId, site) {
    const sites_base_url = this.apiConfig.baseUrl + `/sites`;

    return this.$http.post(sites_base_url + '/' + siteId, site)
      .then((res) => {
        return this._sendResponseData(res);
      })
      .catch((error) => {
        return this._sendError(error);
      });
  }

  getSiteChannel(siteId: string) {

    const deferred = this.$q.defer<FirebaseAuthResponseModel>();
    const sites_base_url = this.apiConfig.baseUrl + `/sites`;

    this.$http.get<FirebaseAuthResponseModel>(sites_base_url + '/' + siteId + '/channel')
      .then((res) => {
        deferred.resolve(res.data);
      })
      .catch((error) => {
        deferred.reject(error)
      })

    return deferred.promise;
  }

  getSitePreferences(siteId, parentGroups?, preferenceGroup?) {
    const sites_base_url = this.apiConfig.baseUrl + `/sites`;
    return this.$http.get(`${sites_base_url}/${siteId}/preferences`, {
      params: {
        preferenceParentGroup: parentGroups,
        preferenceGroup: preferenceGroup
      }
    })
      .then((res) => {
        return this._sendResponseData(res);
      })
      .catch((error) => {
        return this._sendError(error);
      });
  }

  getSitePolicy(siteId, branchIds?) {
    const sites_base_url = this.apiConfig.baseUrl + `/sites`;

    return this.$http.get(sites_base_url + '/' + siteId + '/policy',
      {
        params: {
          branchIds: branchIds
        }
      })
      .then((res) => {
        return this._sendResponseData(res);
      })
      .catch((error) => {
        return this._sendError(error);
      });
  }

  getSiteRolesOld(siteId) {
    const sites_base_url = this.apiConfig.baseUrl + `/sites`;

    return this.$http.get(sites_base_url + '/' + siteId + '/policy/roles')
      .then((res) => {
        return this._sendResponseData(res);
      })
      .catch((error) => {
        return this._sendError(error);
      });
  }

  getSiteRoles(siteId) {
    const sites_base_url = this.apiConfig.baseUrl + `/sites`;

    return this.$http.get(sites_base_url + '/' + siteId + '/policy/memberPermissions')
      .then((res) => {
        return this._sendResponseData(res);
      })
      .catch((error) => {
        return this._sendError(error);
      });
  }

  getSitePlan(siteId) {
    const sites_base_url = this.apiConfig.baseUrl + `/sites`;

    return this.$http.get(sites_base_url + '/' + siteId + '/plan')
      .then((res) => {
        return this._sendResponseData(res);
      })
      .catch((error) => {
        return this._sendError(error);
      });
  }

  updateSitePlanModule(siteId, module) {
    const sites_base_url = this.apiConfig.baseUrl + `/sites`;

    return this.$http.post(sites_base_url + '/' + siteId + '/plan/modules/' + module.id, module)
      .then((res) => {
        return this._sendResponseData(res);
      })
      .catch((error) => {
        return this._sendError(error);
      });
  }

  updateSiteFlavor(siteId, flavorId) {
    const sites_base_url = this.apiConfig.baseUrl + `/sites`;

    return this.$http.post(sites_base_url + '/' + siteId + '/plan/flavor/' + flavorId, undefined)
      .then((res) => {
        return this._sendResponseData(res);
      })
      .catch((error) => {
        return this._sendError(error);
      });
  }

  validatePhoneNumber(siteId, number, countryCode) {
    const url = `${this.apiConfig.baseUrl}/sites/${siteId}/validPhoneNumber`

    return this.$http.get(url, {
      params: {
        number: number,
        countryCode: countryCode
      }
    })
      .then((res) => {
        return this._sendResponseData(res);
      })
      .catch((error) => {
        return this._sendError(error);
      });
  }

  getTravelTimeRules(siteId) {
    const url = `${this.apiConfig.baseUrl}/sites/${siteId}/preferences/routing/travelTimeRules`

    return this.$http.get(url, {
      params: {}
    })
      .then((res) => {
        return this._sendResponseData(res);
      })
      .catch((error) => {
        return this._sendError(error);
      });
  }

  // ******************************
  // Internal methods
  // ******************************

  _sendResponseData(response) {
    return this.$q.when(response.data);
  }

  _sendError(response) {
    return this.$q.reject(response.data);
  }

}

angular
  .module('bringoz.admin.sites')
  .service('sitesRequestsService', SitesRequestsService);
